import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowSplitRight"><Path d="M14.5 3.5H20.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 14.5V20.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12H3.5M12 12L20 4M12 12L20 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowSplitRight;
